import React from "react";
import { Dialog } from "@material-ui/core";
import { CloseIcon } from "../../../../../assets/Icons";
import { styles } from "./styles";
import { AppStrings } from "../../../utils";
import Button from "../../../../../components/ui/Button";

interface ConfirmCancelModalProps {
  visible: boolean;
  title?: string;
  description?: string;
  onConfirm: () => void;
  onClose: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export const ConfirmCancelModal: React.FC<ConfirmCancelModalProps> = ({ 
  visible,
  title = "Are you sure?",
  description = "Do you want to continue?",
  onConfirm,
  onClose,
  loading = false,
  disabled = false
 }) => {
  return (
    <Dialog open={visible}>
      <div className={styles.container}>

        <div className={styles.header.container}>
          <div className={styles.header.title}>{title}</div>
          <CloseIcon className={styles.header.closeIcon} onClick={onClose} />
        </div>

        <span className={styles.message.subText}>
          {description}
        </span>

        <div className={styles.buttons.container}>
          <Button
            bgColor={loading ? "bg-red-200" : "bg-red-500"}
            fontStyle={{
              fontFamily: "font-roboto",
              fontSize: "text-base",
              fontWeight: "font-normal",
              fontColor: "text-white",
            }}
            borderStyle={{
              borderRadius: "rounded",
            }}
            isLoading={loading}
            onClickHandler={onConfirm}
            className={"px-6 py-1 border border-transparent bg-red-500 rounded-lg text-white-200"}
            disabled={disabled}
          >
            {AppStrings.BUTTON.YES}
          </Button>
          <button className={styles.buttons.no} onClick={onClose}>{AppStrings.BUTTON.NO}</button>
        </div>

      </div>
    </Dialog>
  );
};
